import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';
import {LazyLoadImage} from "react-lazy-load-image-component";
import Img from "../../../images/locationgcc/qa/enablement.webp";

function Banner(props) {
    return (
        <div className="enablement p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="banenr_content">
                            <div className="example" data-text="">
                                <h2>The Revol Experience: A Modern App Development Company in Qatar</h2>
                            </div>
                            <p>TekRevol excels in a variety of app development services, backed by 5 years of demonstrated expertise in the global industry. Our track record includes serving numerous businesses with cutting-edge advancements. We incorporate rich feature customizations in our mobile app solutions based on the expertise of our app developers in Qatar. The innovative approach we adopt positions us as the preferred choice for ensuring the sustainability of businesses.</p>
                            <p>As a leading mobile app development company in Qatar, we firmly believe that embracing digital transformation is key for businesses to distinguish themselves in their respective industries. We provide user-friendly digital services using next-gen technologies that cater to businesses of all types.</p>
                            <Link to="/contact"
                                  className="border_btn dark_btn" aria-label="TekRevol Contact"> Let’s Get Started</Link>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;